/*
 * Get-staff.ts
 * Description: Includes the declaration
 * of the function for deleting staff members
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting a staff member
 *
 * @return {Object} Promise - a list of staff members
 * @param {String} slug - id of the restaurant
 * @param {Number} userId - id of the user
 */
export function deleteStaff(slug: string, userId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/users/' + userId,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
